import { useMemo, useState } from "react";
import TableContainer from "../../../../../common/table/TableContainer";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import load from "../../../../../assets/images/load-img.png"
import { getVersementByBusinessId, getVersementByMerchandId } from "../../../../payements/services/paymentApi";
import { useQuery } from "react-query";
import "../../../../payements/utils/paiement.css";
import { FormatCurrency } from "../../../../../common/format/formatCurrency";
import FormatDate from "../../../../../common/format/formatDate";
import DetailRecuVersement from "../detailRecu";

const VersementsHistory = ({busId}) => {

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const merchandId = currentUser?.user?.id || currentUser?.user?.merchantId;
  const role = currentUser?.roles;
  const permissions = currentUser?.user?.permissions;
  const isAuthorized = role == 'COLLABORATOR' ? permissions?.includes('VIEW_PAYOUT') : true;

  const [selectedVersement, setSelectedVersement] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const props = {
    busId : busId,
    token : currentUser?.token,
    merchandId: merchandId
  }
  
  const { data, isLoading, isError, error } = useQuery(
    ["versements", busId],
    () => busId === "all" ? getVersementByMerchandId(props) : getVersementByBusinessId(props),
    {
      enabled: !!merchandId || !!busId,
    }
  );

  const versements = Array.isArray(data?.data) ? data.data : [];

  const columns = useMemo(() => [
    { Header: "Business", accessor: "developerAccountName", filterable: false },
    {
      Header: "Compte",
      accessor: "clientNumber",
      Cell: ({ row }) => {
        const phone = row.original.clientNumber;
        const countryCode = row.original.countryCode;
        /* const prefix = row.original.prefixPhone || ""; */
        const formattedPhoneNumber =parsePhoneNumberFromString(phone, countryCode);
        return formattedPhoneNumber?.formatInternational();
      },
      filterable: false,
    },
    {
      Header: "Montant débité",
      accessor: "amount",
      Cell: ({ row }) => {
        return <span className="">{FormatCurrency(row.original.amount, row.original.currency)}</span>
      },
      filterable: false,
    },   
    {
      Header: "Montant reçu",
      accessor: "realAmount",
      Cell: ({ row }) => {
        return <span className="">{FormatCurrency(row.original.realAmount, row.original.currency)}</span>
      },
      filterable: false,
    },
    {
      Header: "Date de paiement",
      accessor: "createdAt",
      Cell: ({ value }) => <FormatDate date={value} showTime />,
      filterable: false,
    },
    {
      Header: "Statut",
      accessor: "status",
      Cell: ({ value }) => {
        let backgroundColor = "";
        let textColor = "";
        let icon = null;
        let label = "";

        switch (value) {
          case "SUCCESS":
            backgroundColor = "#EBFFEA";
            textColor = "#349C32";
            icon = <CheckOutlined style={{ color: textColor, marginRight: 6 }} />;
            label = "Réussie";
            break;
          case "PENDING":
            backgroundColor = "#F6F6F6";
            textColor = "#FF9F00";
            icon = <img src={load}/>;
            label = " En attente";
            break;
          default:
            backgroundColor = "#FFF2F2";
            textColor = "#E00909";
            icon = <CloseOutlined style={{ color: textColor, marginRight: 6 }} />;
            label = "Non définie";
            break;
        }

        return (
          <span
            style={{
              backgroundColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "20px",
              display: "inline-flex",
              alignItems: "center",
              fontWeight: 500,
              fontSize: 13,
            }}
          >
            {icon}
            {label}
          </span>
        );
      },
      filterable: false,
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <button
          className="btn-consulter"
          onClick={() => {
            setSelectedVersement(row.original);
            setIsModalOpen(true);
          }}
        >
          Consulter
        </button>
      ),
      filterable: false,
    }
  ]);

  return (
    <div className="page-content">
      
      <TableContainer
        columns={columns}
        data={versements || []}
        customPageSize={10}
        className="custom-header-css"
        divClass="table-responsive table-card mb-3"
        tableClass="align-middle table-nowrap"
        theadClass="table-light"
        isLoading={isLoading}
        isError={!isAuthorized || isError ? true : false}
        error={!isAuthorized ? 'Pas autorisé à consulter cette erreur.' : error?.message || 'Une erreur est survenue'}
      />
        
      <DetailRecuVersement
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        selectedVersement={selectedVersement}
      />
    </div>      
  );
};

export default VersementsHistory;


